import type { PropsWithChildren, RefObject } from 'react';
import React, { useMemo } from 'react';

import type { PublicPluginAPI } from '@atlaskit/editor-common/types';
import type { TrackChangesPluginOptions } from '@atlaskit/editor-plugin-track-changes';

import type { AIPlugin } from '@atlassian/editor-plugin-ai';

import { AIStreamingSpotlight } from '@confluence/onboarding-ai-first-create/entry-points/AIStreamingSpotlight';
import { fg } from '@confluence/feature-gating';

export type EditorAPI = PublicPluginAPI<[AIPlugin]>;
export type EditorAPIRef = RefObject<EditorAPI | null | undefined>;

export type TrackChangesPluginProps = {
	editorAPIRef: EditorAPIRef;
};

export type TrackChangesPlugin = {
	pluginOptions: TrackChangesPluginOptions;
};

export const useTrackChangesPlugin = ({
	editorAPIRef,
}: TrackChangesPluginProps): TrackChangesPlugin => {
	const pluginOptions: TrackChangesPluginOptions = useMemo(() => {
		if (!fg('cc_aifc_ai_streaming_spotlight')) {
			return {};
		}

		return {
			ButtonWrapper: ({ children }: PropsWithChildren) => (
				<AIStreamingSpotlight editorAPIRef={editorAPIRef}>{children}</AIStreamingSpotlight>
			),
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { pluginOptions };
};
